const LandingPages = () => {

  // checks for touch-enabled device
  function isTouchDevice() {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
      );
    };

// Check for "Bridging With KENGREAL® (cangrelor)" LP (id 775)
  if (document.querySelector('.page.page-id-775')) {

    // sections
    (function() {
      var s = document.querySelectorAll('#primary [data-obj="section"]');

      s.forEach(section => {
        if (section.getAttribute('data-subj') != 'nav') {
          section.addEventListener('click', (e) => {
            let n = document.querySelector('#primary [data-obj="section"][data-subj="nav"]'),
                m = n.querySelectorAll('[data-obj="menu-item"].open');

            m.forEach(menu => {
              menu.classList.remove('open')
              });
            });
          }
        });
      })();

    // anchor links
    (function() {
      var a = document.querySelectorAll('#primary a[href^="#"]');

      a.forEach(elm => {
        elm.addEventListener('click', (e) => {
          e.preventDefault();

          if (
            isTouchDevice()
            && elm.parentElement.getAttribute('data-obj') == 'menu-item') {
            if (elm.getAttribute('data-option') == 'desktop-only') {
              if (elm.parentElement.classList.contains('open')) {
                let pgHeader = document.getElementById('site-header'),
                    targetID = /^#(.+)$/.exec(elm.getAttribute('href'))[1],
                    targetEl = document.getElementById(targetID),
                    targetOT = targetEl ? (targetEl.offsetTop - (pgHeader.offsetHeight + 50)) : 0;

                window.scrollTo({
                  top: targetOT,
                  behavior: 'smooth',
                  });
                }
            } else {
              let n = document.querySelector('#primary [data-obj="section"][data-subj="nav"]'),
                  m = n.querySelectorAll('[data-obj="menu-item"].open');

              m.forEach(menu => {
                menu.classList.remove('open')
                });

              let pgHeader = document.getElementById('site-header'),
                  targetID = /^#(.+)$/.exec(elm.getAttribute('href'))[1],
                  targetEl = document.getElementById(targetID),
                  targetOT = targetEl ? (targetEl.offsetTop - (pgHeader.offsetHeight + 50)) : 0;

              window.scrollTo({
                top: targetOT,
                behavior: 'smooth',
                });
            }
          } else {
            let pgHeader = document.getElementById('site-header'),
                targetID = /^#(.+)$/.exec(elm.getAttribute('href'))[1],
                targetEl = document.getElementById(targetID),
                targetOT = targetEl ? (targetEl.offsetTop - (pgHeader.offsetHeight + 50)) : 0;

            window.scrollTo({
              top: targetOT,
              behavior: 'smooth',
              });
            }
          });
        });
      })();

    // image description toggles
    (function() {
      var s = '#primary [data-obj="section"] [data-obj="img-toggle"] [data-obj="toggle"]',
          t = document.querySelectorAll(s);

      t.forEach(elm => {
        elm.addEventListener('click', (e) => {
          elm.parentElement.classList.toggle('open')
          });
        });
      })();

    // main menu
    (function() {

      (function() {
        var n = document.querySelector('#primary [data-obj="section"][data-subj="nav"]'),
            m = n.querySelectorAll('[data-obj="menu-item"]');

        m.forEach(menu => {
          if (isTouchDevice()) {
              if (menu.getAttribute('data-subs') == 'yes') {
                menu.addEventListener('click', (e) => {
                  menu.classList.toggle('open');

                  if (menu.classList.contains('open')) {
                    let n = menu.getAttribute('data-name'),
                        s = `#primary [data-obj="section"][data-subj="nav"] [data-obj="menu-item"]:not([data-name="${n}"]).open`,
                        o = document.querySelectorAll(s);

                    o.forEach(other => {
                      other.classList.remove('open')
                      });
                    }
                  });
                }
            } else {
              menu.addEventListener('mouseover', (e) => {
                menu.classList.add('open')
                });

              menu.addEventListener('mouseout', (e) => {
                menu.classList.remove('open')
                });
            }
          });
        })();
      })();

    // listen for window scroll
    window.addEventListener('scroll', function() {
      let y = window.scrollY,
          b = document.querySelector('[data-obj="btn"][data-subj="backtotop"]'),
          c = 'open';

      y < 500
        ? b.classList.remove(c)
        : b.classList.add(c);
      });

    // back to top button
    (function() {
      var b = document.querySelector('[data-obj="btn"][data-subj="backtotop"]');

      b.addEventListener('click', (e) => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
          });
        });
      })();

    // disclosures module
    (function() {
      var c = document.querySelector('#primary [data-obj="section"][data-name="disclosures"]'),
          t = c.querySelector('[data-obj="btn"][data-subj="toggle"]');

      t.addEventListener('click', function(e) {
        this.parentElement.scrollTo(0, 0);
        this.parentElement.parentElement.classList.toggle('open')
        });
      })();

    // Code to execute when the page finishes loading
    window.addEventListener('load', (event) => {

      // back to top button
      (function() {
        let y = window.scrollY,
            b = document.querySelector('[data-obj="btn"][data-subj="backtotop"]'),
            c = 'open';

        y < 500
          ? b.classList.remove(c)
          : b.classList.add(c);
        })();
      });
  }
};

export default LandingPages
